<template>
  <div class="forgot-password-page" dir="rtl">
    <div class="logo-container">
      <img
        src="@/assets/image/3 - With text.png"
        alt="أكاديمية الدكتور"
        class="logo"
      />
    </div>

    <div class="forgot-password-form">
      <h2 class="form-title">نسيت كلمة المرور</h2>
      <p class="form-description">
        أدخل بريدك الإلكتروني وسنرسل لك رابطاً لإعادة تعيين كلمة المرور
      </p>

      <form @submit.prevent="handleForgotPassword">
        <div class="form-group">
          <label for="email" class="form-label">البريد الإلكتروني</label>
          <input
            type="email"
            class="form-control"
            id="email"
            v-model="email"
            placeholder="أدخل البريد الإلكتروني"
            required
            :disabled="loading"
          />
        </div>

        <button 
          type="submit" 
          class="btn btn-primary"
          :disabled="loading"
        >
          <span v-if="loading">جاري الإرسال...</span>
          <span v-else>إرسال رابط إعادة التعيين</span>
        </button>

        <div class="back-to-login">
          <router-link to="/login" class="link">العودة إلى تسجيل الدخول</router-link>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import apiClient from "@/api";
import Swal from "sweetalert2";

export default {
  name: "ForgotPasswordPage",
  data() {
    return {
      email: "",
      loading: false,
    };
  },
  methods: {
    async handleForgotPassword() {
      if (!this.email) {
        Swal.fire({
          icon: "error",
          title: "خطأ",
          text: "يرجى إدخال البريد الإلكتروني",
          confirmButtonText: "حسنًا",
        });
        return;
      }

      this.loading = true;

      try {
        const response = await apiClient.post(
          "/api/Auth/ForgotPassword",
          {
            email: this.email,
          }
        );

        if (response.status === 200 && !response.data.error) {
          Swal.fire({
            icon: "success",
            title: "تم الإرسال",
            text: response.data.message || "تم إرسال رابط إعادة تعيين كلمة المرور إلى بريدك الإلكتروني",
            confirmButtonText: "حسنًا",
          }).then(() => {
            // إعادة التوجيه إلى صفحة تسجيل الدخول
            this.$router.push("/login");
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "خطأ",
            text:
              response.data.message ||
              "فشل إرسال رابط إعادة التعيين، يرجى المحاولة مرة أخرى",
            confirmButtonText: "حسنًا",
          });
        }
      } catch (error) {
        console.error("خطأ أثناء طلب إعادة تعيين كلمة المرور:", error);
        
        let errorMessage = "فشل إرسال رابط إعادة التعيين، يرجى المحاولة مرة أخرى";
        
        if (error.response && error.response.data) {
          errorMessage = error.response.data.message || errorMessage;
        }

        Swal.fire({
          icon: "error",
          title: "خطأ",
          text: errorMessage,
          confirmButtonText: "حسنًا",
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
/* إعدادات عامة للصفحة */
.forgot-password-page {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #f0f4f8, #d9e2ec);
  padding: 20px;
}

/* صندوق الشعار */
.logo-container {
  margin-bottom: 30px;
  text-align: center;
}

/* تعديل حجم الشعار ليناسب الهوية */
.logo {
  width: 300px;
  height: auto;
}

/* تصميم نموذج نسيت كلمة المرور */
.forgot-password-form {
  background-color: #ffffff;
  padding: 40px 30px;
  border-radius: 12px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 450px;
}

/* عنوان النموذج */
.form-title {
  margin-bottom: 10px;
  color: #002f49;
  text-align: center;
  font-size: 24px;
  font-weight: 400;
}

/* وصف النموذج */
.form-description {
  margin-bottom: 25px;
  color: #666;
  text-align: center;
  font-size: 14px;
  line-height: 1.6;
}

/* تنسيق حقول النموذج */
.form-group {
  margin-bottom: 20px;
}

.form-label {
  display: block;
  margin-bottom: 8px;
  color: #002f49;
  font-weight: 600;
}

.form-control {
  direction: rtl;
  width: 100%;
  padding: 10px 15px;
  border: 1px solid #ccd0d5;
  border-radius: 6px;
  font-size: 16px;
  transition: border-color 0.3s;
}

.form-control:focus {
  border-color: #002f49;
  outline: none;
  box-shadow: 0 0 5px rgba(0, 47, 73, 0.2);
}

.form-control:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

/* زر الإرسال */
.btn-primary {
  width: 100%;
  background-color: #002f49;
  border: none;
  padding: 12px;
  font-size: 16px;
  color: #ffffff;
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.3s;
  margin-top: 10px;
}

.btn-primary:hover:not(:disabled) {
  background-color: #001f33;
}

.btn-primary:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
  opacity: 0.6;
}

/* رابط العودة لتسجيل الدخول */
.back-to-login {
  margin-top: 20px;
  text-align: center;
}

.link {
  color: #002f49;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s;
}

.link:hover {
  color: #001f33;
  text-decoration: underline;
}

/* تحسينات للشاشات الصغيرة */
@media (max-width: 480px) {
  .forgot-password-form {
    padding: 30px 20px;
  }

  .logo {
    width: 250px;
  }

  .form-title {
    font-size: 20px;
  }
}
</style>



